import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AppModule } from '../../app.module';
import { IncidentCloseRequest } from '../../models/incident';
import { NotificationService } from '../../shared/notification.service';
import { IncidentService } from '../../shared/incident.service';
import { SharedDataService } from '../../shared/shareddata.service';

@Component({
  selector: 'app-incident-close-modal',
  imports: [AppModule],
  templateUrl: './incident-close-modal.html',
  styleUrl: './incident-close-modal.less'
})
export class IncidentCloseModal implements OnChanges {
  @Input() visible: boolean = false;
  @Input() incidentId: number = 0;
  @Input() orderNumber: string = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() incidentClosed = new EventEmitter<void>();

  public closeRequest: IncidentCloseRequest = new IncidentCloseRequest();
  public isLoading: boolean = false;

  constructor(
    private incidentService: IncidentService,
    private notification: NotificationService,
    public sharedDataService: SharedDataService
  ) {}

  ngOnChanges() {
    if (this.visible && this.incidentId) {
      this.closeRequest = new IncidentCloseRequest();
      this.closeRequest.workDone = '';
      this.closeRequest.comment = '';
      this.closeRequest.orderNumber = this.orderNumber || '';
      this.closeRequest.incidentId = this.incidentId;
      this.closeRequest.dateCompleted = new Date();
    }
  }

  public onCancel() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public onConfirmCloseIncident() {
    // Validate required fields
    
    if (!this.closeRequest.dateCompleted) {
      this.notification.showError('Date completed is required');
      return;
    }
    if (!this.closeRequest.workDone || this.closeRequest.workDone.trim() === '') {
      this.notification.showError('Work done is required');
      return;
    }
    
    this.isLoading = true;
    this.incidentService.closeIncident(this.incidentId, this.closeRequest).subscribe({
      next: (incident) => {
        this.isLoading = false;
        this.visible = false;
        this.visibleChange.emit(false);
        this.notification.showSuccess("Breakdown has been closed.");
        this.incidentClosed.emit();
      },
      error: (error) => {
        this.isLoading = false;
        this.notification.handleError(error, "Failed to close breakdown. Please try again.");
      }
    });
  }
}
